export const lastBookingFilter = [
  { title: 'Car Park Code', value: 'carParkCode' },
  { title: 'Phone', value: 'phone' },
  { title: 'Registration Mark', value: 'registrationMark' },
];
